module.exports = {
  "embeddedReportView": {
    "name": "embedded report view",
    "class": "view",
    "properties": {
      "action": "string"
    },
    "namespace": "reporting"
  },
  "embeddedReportInteraction": {
    "name": "embedded report interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "value": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting"
  },
  "quoteApprovalActivation": {
    "properties": {
      "action": [
        "Create quote workflows"
      ],
      "version": [
        "v1",
        "v2"
      ]
    },
    "namespace": "quotes-admin",
    "name": "Quotes activation",
    "class": "activation"
  },
  "createQuote": {
    "name": "Quote create",
    "properties": {
      "action": [
        "Created quote",
        "Drafted quote",
        "Requested quote"
      ],
      "template": [
        "ORIGINAL",
        "BASIC",
        "MODERN"
      ],
      "numberOfRecipientContacts": {
        "type": "number"
      },
      "signatureEnabled": {
        "type": "boolean"
      },
      "esignatureEnabled": {
        "type": "boolean"
      },
      "stripeEnabled": {
        "type": "boolean"
      }
    },
    "namespace": "quotes-admin",
    "class": "usage"
  },
  "quoteApprovalUsage": {
    "properties": {
      "action": [
        "Approved quote",
        "Requested quote changes"
      ]
    },
    "namespace": "quotes-admin",
    "name": "Quotes usage",
    "class": "usage"
  },
  "quoteWizardProgress": {
    "properties": {
      "action": [
        "Quote wizard progress"
      ],
      "step": [
        "Quote details",
        "Buyer information",
        "Sender information",
        "Review products",
        "Signature and payment",
        "Review"
      ]
    },
    "namespace": "quotes-admin",
    "name": "Quotes interaction",
    "class": "interaction"
  },
  "quoteWizardCancel": {
    "properties": {
      "action": [
        "Cancel quote"
      ],
      "location": [
        "create flow",
        "edit flow"
      ]
    },
    "namespace": "quotes-admin",
    "name": "Quotes interaction",
    "class": "interaction"
  },
  "quoteCardInteraction": {
    "properties": {
      "action": [
        "Click quote title",
        "Copy quote link",
        "Copy quote approval link",
        "Edit quote",
        "Download quote",
        "Countersign quote",
        "View esign signatures",
        "Delete quote"
      ]
    },
    "namespace": "quotes-admin",
    "name": "Quotes interaction",
    "class": "interaction"
  },
  "quoteApprovalPermissionSetup": {
    "properties": {
      "action": [
        "Open quote approval permissions modal",
        "Confirm quote approval permissions modal"
      ]
    },
    "namespace": "quotes-admin",
    "name": "Quotes interaction",
    "class": "interaction"
  },
  "quoteApprovalWorkflowSetup": {
    "properties": {
      "action": [
        "Open quote approval notifications modal",
        "Confirm quote approval notifications modal",
        "Manage quote approval workflows"
      ]
    },
    "namespace": "quotes-admin",
    "name": "Quotes interaction",
    "class": "interaction"
  },
  "quoteTimelineEvent": {
    "properties": {
      "action": [
        "Click public quote link"
      ]
    },
    "namespace": "quotes-admin",
    "name": "Quotes interaction",
    "class": "interaction"
  },
  "productPanelUsage": {
    "name": "Product panel",
    "properties": {
      "action": [
        "Create product",
        "Edit product"
      ],
      "subAction": [
        "Save",
        "Save and add another"
      ],
      "propertyName": {
        "type": "string"
      }
    },
    "namespace": "products",
    "class": "usage"
  },
  "productExport": {
    "name": "Products export",
    "properties": {
      "action": [
        "Export success"
      ],
      "subAction": [
        "Export specific objects",
        "Export all objects"
      ],
      "containsSearchQuery": {
        "type": "boolean"
      }
    },
    "namespace": "products",
    "class": "usage"
  },
  "deleteObject": {
    "properties": {
      "action": [
        "Delete product",
        "Delete folder"
      ]
    },
    "namespace": "products",
    "name": "Products usage",
    "class": "usage"
  },
  "bulkDeleteObjects": {
    "properties": {
      "action": [
        "Bulk delete"
      ],
      "containsSearchQuery": {
        "type": "boolean"
      }
    },
    "namespace": "products",
    "name": "Products usage",
    "class": "usage"
  },
  "modifyFolderModal": {
    "properties": {
      "action": [
        "Create folder",
        "Edit folder"
      ]
    },
    "namespace": "products",
    "name": "Products usage",
    "class": "usage"
  },
  "moveProductToFolder": {
    "properties": {
      "action": [
        "Move product to folder"
      ]
    },
    "namespace": "products",
    "name": "Products usage",
    "class": "usage"
  },
  "updateBuyNowLink": {
    "properties": {
      "action": [
        "Update buy now link"
      ]
    },
    "namespace": "products",
    "name": "Products usage",
    "class": "usage"
  },
  "openProductPanel": {
    "properties": {
      "action": [
        "Create product",
        "Edit product"
      ]
    },
    "namespace": "products",
    "name": "Products interaction",
    "class": "interaction"
  },
  "productLibraryFilter": {
    "properties": {
      "action": [
        "Filter product library"
      ]
    },
    "namespace": "products",
    "name": "Products interaction",
    "class": "interaction"
  },
  "viewBuyNowLink": {
    "properties": {
      "action": [
        "View buy now link"
      ]
    },
    "namespace": "products",
    "name": "Products interaction",
    "class": "interaction"
  },
  "bulkSaveLineItems": {
    "properties": {
      "action": [
        "Bulk save line items"
      ]
    },
    "namespace": "line-items",
    "name": "LineItems usage",
    "class": "usage"
  },
  "updateDealAmount": {
    "properties": {
      "action": [
        "Update deal amount"
      ]
    },
    "namespace": "line-items",
    "name": "LineItems usage",
    "class": "usage"
  },
  "addLineItem": {
    "properties": {
      "action": [
        "Add line item"
      ],
      "screen": [
        "DEAL",
        "QUOTE"
      ]
    },
    "namespace": "line-items",
    "name": "LineItems interaction",
    "class": "interaction"
  },
  "editLineItem": {
    "properties": {
      "action": [
        "Edit line item"
      ],
      "screen": [
        "DEAL",
        "QUOTE"
      ],
      "propertyName": {
        "type": "string"
      },
      "isInlineEdit": "boolean"
    },
    "namespace": "line-items",
    "name": "LineItems interaction",
    "class": "interaction"
  },
  "removeLineItem": {
    "properties": {
      "action": [
        "Remove line item"
      ],
      "screen": [
        "DEAL",
        "QUOTE"
      ]
    },
    "namespace": "line-items",
    "name": "LineItems interaction",
    "class": "interaction"
  },
  "resolveInvalidCurrencies": {
    "properties": {
      "action": [
        "Resolve line item currencies"
      ]
    },
    "namespace": "line-items",
    "name": "LineItems interaction",
    "class": "interaction"
  },
  "modifyDealAmountReportingFrequency": {
    "properties": {
      "action": [
        "Modify reporting frequency"
      ],
      "frequency": [
        "monthly",
        "quarterly",
        "per_six_months",
        "annually",
        "per_two_years",
        "per_three_years"
      ]
    },
    "namespace": "line-items",
    "name": "LineItems interaction",
    "class": "interaction"
  },
  "PACWidget": {
    "name": "PAC interaction",
    "class": "usage",
    "properties": {
      "action": "string",
      "subAction": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "crm"
  },
  "use-android-app-installprompt": {
    "name": "use-android-app-installprompt",
    "class": "interaction",
    "properties": {
      "what_event_subtype": "string"
    },
    "namespace": "crm"
  },
  "use-bulk-add-to-list": {
    "name": "use-bulk-add-to-list",
    "class": "usage",
    "namespace": "crm"
  },
  "use-bulk-create-tasks": {
    "name": "use-bulk-create-tasks",
    "class": "usage",
    "properties": {
      "what_event_subtype": "string"
    },
    "namespace": "crm"
  },
  "use-bulk-enroll-in-sequence": {
    "name": "use-bulk-enroll-in-sequence",
    "class": "usage",
    "namespace": "crm"
  },
  "use-bulk-enroll-in-workflow": {
    "name": "use-bulk-enroll-in-workflow",
    "class": "usage",
    "namespace": "crm"
  },
  "use-bulk-remove-from-list": {
    "name": "use-bulk-remove-from-list",
    "class": "usage",
    "namespace": "crm"
  },
  "use-linked-sales-object-iframe": {
    "name": "use-linked-sales-object-iframe",
    "class": "usage",
    "properties": {
      "applicationName": "string"
    },
    "namespace": "crm"
  },
  "use-registernumber": {
    "name": "use-registernumber",
    "class": "usage",
    "properties": {
      "where_app_override": "string"
    },
    "namespace": "crm"
  },
  "use-sequence-timeline-edit": {
    "name": "use-sequence-timeline-edit",
    "class": "usage",
    "namespace": "crm"
  },
  "use-sfdc-card-clicked-force-sync": {
    "name": "use-sfdc-card-clicked-force-sync",
    "class": "usage",
    "namespace": "crm"
  },
  "inserted-content-from-popover": {
    "name": "inserted-content-from-popover",
    "class": "interaction",
    "properties": {
      "sawPopover": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "crm"
  },
  "inserted-snippet": {
    "name": "inserted-snippet",
    "class": "interaction",
    "namespace": "crm"
  },
  "settings-interaction": {
    "name": "settings-interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "app": {
        "type": "string",
        "isOptional": true
      },
      "actionType": {
        "type": [
          "CONTACT",
          "COMPANY",
          "DEAL",
          "TASK",
          "TICKET"
        ],
        "isOptional": true
      },
      "subAction": {
        "type": "string",
        "isOptional": true
      },
      "clientType": {
        "type": "string",
        "isOptional": true
      },
      "quotasChanged": {
        "type": "number",
        "isOptional": true
      }
    },
    "namespace": "settingsui"
  },
  "settingsInteractionWithType": {
    "name": "settings interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "type": "string"
    },
    "namespace": "settingsui"
  },
  "settingsInteractionWithSuccess": {
    "name": "settings interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "type": {
        "type": "boolean"
      }
    },
    "namespace": "settingsui"
  },
  "settings-email-plugin-check-retry-clicked": {
    "name": "settings-email-plugin-check-retry-clicked",
    "class": "interaction",
    "namespace": "settingsui"
  },
  "settings-enable-company-autocreate": {
    "name": "settings-enable-company-autocreate",
    "class": "interaction",
    "namespace": "settingsui"
  },
  "settings-import-export-clicked-import-button": {
    "name": "settings-import-export-clicked-import-button",
    "class": "interaction",
    "namespace": "settingsui"
  },
  "settings-start-company-autocreate-backfill": {
    "name": "settings-start-company-autocreate-backfill",
    "class": "interaction",
    "namespace": "settingsui"
  },
  "view-settings-activitytypes": {
    "name": "view-settings-activitytypes",
    "class": "view",
    "properties": {
      "screen": "string",
      "subscreen": "string"
    },
    "namespace": "settingsui"
  },
  "view-settings-bcc": {
    "name": "view-settings-bcc",
    "class": "view",
    "properties": {
      "screen": "string",
      "subscreen": "string"
    },
    "namespace": "settingsui"
  },
  "view-settings-calling": {
    "name": "view-settings-calling",
    "class": "view",
    "properties": {
      "screen": "string",
      "subscreen": "string"
    },
    "namespace": "settingsui"
  },
  "view-settings-companies": {
    "name": "view-settings-companies",
    "class": "view",
    "properties": {
      "screen": "string",
      "subscreen": "string"
    },
    "namespace": "settingsui"
  },
  "view-settings-config": {
    "name": "view-settings-config",
    "class": "view",
    "properties": {
      "screen": "string",
      "subscreen": "string"
    },
    "namespace": "settingsui"
  },
  "view-settings-contacts": {
    "name": "view-settings-contacts",
    "class": "view",
    "properties": {
      "screen": "string",
      "subscreen": "string"
    },
    "namespace": "settingsui"
  },
  "view-settings-deals": {
    "name": "view-settings-deals",
    "class": "view",
    "properties": {
      "screen": "string",
      "subscreen": "string"
    },
    "namespace": "settingsui"
  },
  "view-settings-email": {
    "name": "view-settings-email",
    "class": "view",
    "properties": {
      "screen": "string",
      "subscreen": "string"
    },
    "namespace": "settingsui"
  },
  "view-settings-importexport": {
    "name": "view-settings-importexport",
    "class": "view",
    "properties": {
      "screen": "string",
      "subscreen": "string"
    },
    "namespace": "settingsui"
  },
  "view-settings-notifications": {
    "name": "view-settings-notifications",
    "class": "view",
    "properties": {
      "screen": "string",
      "subscreen": "string"
    },
    "namespace": "settingsui"
  },
  "view-settings-privacy": {
    "name": "view-settings-privacy",
    "class": "view",
    "properties": {
      "screen": "string",
      "subscreen": "string"
    },
    "namespace": "settingsui"
  },
  "view-settings-supportForm": {
    "name": "view-settings-supportForm",
    "class": "view",
    "properties": {
      "screen": "string",
      "subscreen": "string"
    },
    "namespace": "settingsui"
  },
  "view-settings-salestools": {
    "name": "view-settings-salestools",
    "class": "view",
    "properties": {
      "screen": "string",
      "subscreen": "string"
    },
    "namespace": "settingsui"
  },
  "view-settings-tasks": {
    "name": "view-settings-tasks",
    "class": "view",
    "properties": {
      "screen": "string",
      "subscreen": "string"
    },
    "namespace": "settingsui"
  },
  "view-settings-tickets": {
    "name": "view-settings-tickets",
    "class": "view",
    "properties": {
      "screen": "string",
      "subscreen": "string"
    },
    "namespace": "settingsui"
  },
  "view-listcreate": {
    "name": "view-listcreate",
    "class": "view",
    "properties": {
      "action": "string",
      "screen": "string",
      "subscreen": {
        "isOptional": true,
        "type": "string"
      }
    },
    "namespace": "lists"
  },
  "view-listdetail": {
    "name": "view-listdetail",
    "class": "view",
    "properties": {
      "action": "string",
      "screen": "string",
      "subscreen": {
        "isOptional": true,
        "type": "string"
      }
    },
    "namespace": "lists"
  },
  "view-listsindex": {
    "name": "view-listsindex",
    "class": "view",
    "properties": {
      "action": "string",
      "screen": "string",
      "subscreen": {
        "isOptional": true,
        "type": "string"
      }
    },
    "namespace": "lists"
  },
  "listsPageview": {
    "name": "pageview",
    "class": "view",
    "properties": {
      "screen": "string"
    },
    "namespace": "lists"
  },
  "listsInteraction": {
    "name": "lists interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "subAction": {
        "type": "string",
        "isOptional": true
      },
      "type": {
        "type": "string",
        "isOptional": true
      },
      "condition": {
        "type": "string",
        "isOptional": true
      },
      "filterFamily": {
        "type": "string",
        "isOptional": true
      },
      "panelKey": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "lists"
  },
  "addContactsToRestrictedList": {
    "name": "lists interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "count": "number"
    },
    "namespace": "lists"
  },
  "communicatorInteraction": {
    "name": "communicator interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "source": {
        "type": "string",
        "isOptional": true
      },
      "channel": {
        "type": "string",
        "isOptional": true
      },
      "activity": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "communicator"
  },
  "communicatorSettingsInteraction": {
    "name": "Manage Settings",
    "namespace": "calling",
    "class": "interaction",
    "properties": {
      "action": "string",
      "provider_name": {
        "type": "string",
        "isOptional": true
      }
    }
  },
  "communicator_SelectCallOutCome": {
    "name": "communicator interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "select call outcome"
      ],
      "source": {
        "type": "string",
        "isOptional": true
      },
      "channel": {
        "type": "string",
        "isOptional": true
      },
      "activity": {
        "type": "string",
        "isOptional": true
      },
      "outcomeType": {
        "type": "string"
      }
    },
    "namespace": "communicator"
  },
  "communicator_SelectCallType": {
    "name": "communicator interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "select call type"
      ],
      "source": {
        "type": "string",
        "isOptional": true
      },
      "channel": {
        "type": "string",
        "isOptional": true
      },
      "activity": {
        "type": "string",
        "isOptional": true
      },
      "callType": {
        "type": "string"
      }
    },
    "namespace": "communicator"
  },
  "communicator_RateCall": {
    "name": "communicator interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "rate call quality"
      ],
      "source": {
        "type": "string",
        "isOptional": true
      },
      "channel": {
        "type": "string",
        "isOptional": true
      },
      "activity": {
        "type": "string",
        "isOptional": true
      },
      "callRating": {
        "type": "number"
      }
    },
    "namespace": "communicator"
  },
  "communicator_Feedback": {
    "name": "communicator interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "call quality feedback"
      ],
      "source": {
        "type": "string",
        "isOptional": true
      },
      "channel": {
        "type": "string",
        "isOptional": true
      },
      "activity": {
        "type": "string",
        "isOptional": true
      },
      "feedback": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "communicator"
  },
  "communicator_SaveCall": {
    "name": "communicator interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "save call"
      ],
      "source": {
        "type": "string",
        "isOptional": true
      },
      "channel": {
        "type": "string",
        "isOptional": true
      },
      "activity": {
        "type": "string",
        "isOptional": true
      },
      "outcomeType": {
        "type": "string",
        "isOptional": true
      },
      "callType": {
        "type": "string",
        "isOptional": true
      },
      "noteCharacterCount": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "communicator"
  },
  "communicator_ProviderSwitch": {
    "name": "communicator interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "provider switch"
      ],
      "source": {
        "type": "string",
        "isOptional": true
      },
      "channel": {
        "type": "string",
        "isOptional": true
      },
      "activity": {
        "type": "string",
        "isOptional": true
      },
      "switchFrom": {
        "type": "string"
      },
      "switchTo": {
        "type": "string"
      }
    },
    "namespace": "communicator"
  },
  "communicator_fileInteraction": {
    "name": "communicator interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "source": {
        "type": "string",
        "isOptional": true
      },
      "channel": {
        "type": "string",
        "isOptional": true
      },
      "activity": {
        "type": "string",
        "isOptional": true
      },
      "fileType": {
        "type": "string"
      },
      "fileSource": {
        "type": "string"
      }
    },
    "namespace": "communicator"
  },
  "communicator_callActivation": {
    "name": "call activation",
    "class": "activation",
    "namespace": "communicator"
  },
  "communicator_firstCallActivation": {
    "name": "first call activation",
    "class": "activation",
    "namespace": "communicator"
  },
  "callUsage_startCall": {
    "name": "start call",
    "class": "usage",
    "properties": {
      "action": [
        "start call"
      ],
      "callMedium": {
        "type": "string"
      },
      "provider": {
        "type": "string"
      }
    },
    "namespace": "communicator"
  },
  "communicatorUsage_createFollowUpTask": {
    "name": "create followup task",
    "class": "usage",
    "properties": {
      "action": {
        "type": "string",
        "isOptional": true
      },
      "source": {
        "type": "string",
        "isOptional": true
      },
      "channel": {
        "type": "string",
        "isOptional": true
      },
      "activity": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "communicator"
  },
  "communicator_callSignup": {
    "name": "call signup",
    "class": "interaction",
    "properties": {
      "action": [
        "zero state",
        "add phone number",
        "registration complete"
      ]
    },
    "namespace": "communicator"
  },
  "calling_manageSettings": {
    "name": "manage settings",
    "class": "interaction",
    "properties": {
      "action": [
        "add phone number",
        "delete phone number",
        "connect to third party provider",
        "enable recording",
        "disconnect calling",
        "enable calling"
      ]
    },
    "namespace": "communicator"
  },
  "communicator_emailActivation": {
    "name": "email activation",
    "class": "activation",
    "namespace": "communicator"
  },
  "communicator_firstEmailActivation": {
    "name": "first email activation",
    "class": "activation",
    "namespace": "communicator"
  },
  "communicator_timelineInteraction": {
    "name": "timeline interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "email reply",
        "email reply all",
        "email reply to n",
        "cancel email"
      ],
      "source": {
        "type": "string",
        "isOptional": true
      },
      "channel": {
        "type": "string",
        "isOptional": true
      },
      "activity": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "communicator"
  },
  "communicator_formatText": {
    "name": "communicator interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "format text"
      ],
      "source": {
        "type": "string",
        "isOptional": true
      },
      "channel": {
        "type": "string",
        "isOptional": true
      },
      "activity": {
        "type": "string",
        "isOptional": true
      },
      "formatType": {
        "type": "string"
      }
    },
    "namespace": "communicator"
  },
  "communicator_saveSignature": {
    "name": "communicator interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "save signature"
      ],
      "source": {
        "type": "string",
        "isOptional": true
      },
      "channel": {
        "type": "string",
        "isOptional": true
      },
      "activity": {
        "type": "string",
        "isOptional": true
      },
      "signatureType": {
        "type": "string"
      }
    },
    "namespace": "communicator"
  },
  "communicator_recipientInteraction": {
    "name": "communicator interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "Add \"to\" recipient",
        "Add \"cc\" recipient",
        "Add \"bcc\" recipient"
      ],
      "source": {
        "type": "string",
        "isOptional": true
      },
      "channel": {
        "type": "string",
        "isOptional": true
      },
      "activity": {
        "type": "string",
        "isOptional": true
      },
      "count": {
        "type": "number"
      }
    },
    "namespace": "communicator"
  },
  "communicator_sendEmail": {
    "name": "communicator interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "click to send email",
        "click to schedule email"
      ],
      "source": {
        "type": "string",
        "isOptional": true
      },
      "channel": {
        "type": "string",
        "isOptional": true
      },
      "activity": {
        "type": "string",
        "isOptional": true
      },
      "emailType": "string",
      "replyAllCount": "number",
      "scheduleEmailType": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "communicator"
  },
  "communicatorUsage_sendEmail": {
    "name": "send email",
    "class": "usage",
    "properties": {
      "emailType": "string",
      "replyAllCount": "number",
      "source": "string",
      "scheduleEmailType": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "communicator"
  },
  "callingSignup": {
    "name": "signup",
    "class": "signup",
    "properties": {
      "action": "string",
      "completed onboarding": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "calling"
  },
  "callingInteraction": {
    "name": "calling interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "provider_name": {
        "type": "string",
        "isOptional": true
      },
      "property_name": {
        "type": "string",
        "isOptional": true
      },
      "reason": {
        "type": "string",
        "isOptional": true
      },
      "is_recording": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "calling"
  },
  "startCall": {
    "name": "start call",
    "class": "usage",
    "properties": {
      "type": "string",
      "inOnboarding": {
        "type": "boolean",
        "isOptional": true
      },
      "call from": {
        "type": "string",
        "isOptional": true
      },
      "iframe": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "calling"
  },
  "view-indexinteraction": {
    "name": "index-interaction",
    "class": "view",
    "properties": {
      "action": "string",
      "screen": "string",
      "subscreen": {
        "isOptional": true,
        "type": "string"
      }
    },
    "namespace": "crm"
  },
  "view-recordinteraction": {
    "name": "record-interaction",
    "class": "view",
    "properties": {
      "action": "string",
      "screen": "string",
      "subscreen": {
        "isOptional": true,
        "type": "string"
      }
    },
    "namespace": "crm"
  },
  "bizops-interaction": {
    "name": "bizops-interaction",
    "class": "interaction",
    "properties": {
      "action": "string"
    },
    "namespace": "crm"
  },
  "internal-crm-tracking": {
    "name": "internal-crm-tracking",
    "class": "interaction",
    "properties": {
      "cachedVersion": "string",
      "asset": "string"
    },
    "namespace": "crm"
  },
  "createRecord": {
    "name": "create record",
    "class": "usage",
    "properties": {
      "type": "string"
    },
    "namespace": "crm"
  },
  "createRecordActivation": {
    "name": "create first record",
    "class": "activation",
    "properties": {
      "type": [
        "contact",
        "company",
        "deal",
        "ticket"
      ]
    },
    "namespace": "crm"
  },
  "ownedContactsActivation": {
    "name": "fetch owned contacts temporary",
    "class": "activation",
    "properties": {
      "count": "number"
    },
    "namespace": "crm"
  },
  "createEngagementActivation": {
    "name": "create first engagement",
    "class": "activation",
    "properties": {
      "type": [
        "email",
        "task",
        "call",
        "meeting",
        "note"
      ]
    },
    "namespace": "crm"
  },
  "activate-viewed-contact-profile": {
    "name": "activate-viewed-contact-profile",
    "class": "activation",
    "properties": {
      "type": "string"
    },
    "namespace": "crm"
  },
  "crmActivation": {
    "name": "crm activation",
    "class": "activation",
    "properties": {
      "type": "string"
    },
    "namespace": "crm"
  },
  "crm-onboarding": {
    "name": "crm-onboarding",
    "class": "interaction",
    "properties": {
      "action": {
        "type": "string",
        "isOptional": true
      },
      "type": {
        "type": "string",
        "isOptional": true
      },
      "subAction": {
        "type": "string",
        "isOptional": true
      },
      "link": {
        "type": "string",
        "isOptional": true
      },
      "text": {
        "type": "string",
        "isOptional": true
      },
      "experiment": {
        "type": "string",
        "isOptional": true
      },
      "step": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "crm"
  },
  "crm-debug": {
    "name": "crm-debug",
    "class": "interaction",
    "properties": {
      "action": "string",
      "consumer": "string"
    },
    "namespace": "crm"
  },
  "debugChunkLoadIssues": {
    "name": "crm-debug",
    "class": "interaction",
    "properties": {
      "chunk": "string",
      "error": "string"
    },
    "namespace": "crm"
  },
  "crm-api-error": {
    "name": "crm-api-error",
    "class": "interaction",
    "properties": {
      "action": "string",
      "taskId": "number"
    },
    "namespace": "crm"
  },
  "exportView": {
    "name": "index interaction",
    "class": "usage",
    "properties": {
      "action": "string",
      "exportedPropertiesNum": "number",
      "exportType": "string"
    },
    "namespace": "crm"
  },
  "addedAttachment": {
    "name": "record interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "subAction": "string"
    },
    "namespace": "crm"
  },
  "emailRecipientsAdded": {
    "name": "record interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "subAction": "string",
      "count": "number"
    },
    "namespace": "crm"
  },
  "emailCommunicatorInteraction": {
    "name": "record interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "subAction": "string"
    },
    "namespace": "crm"
  },
  "index-interaction": {
    "name": "index-interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "subAction": {
        "type": "string",
        "isOptional": true
      },
      "type": {
        "type": "string",
        "isOptional": true
      },
      "count": {
        "type": "number",
        "isOptional": true
      }
    },
    "namespace": "crm"
  },
  "indexUsage": {
    "name": "index interaction",
    "class": "usage",
    "properties": {
      "action": "string",
      "subAction": {
        "type": "string",
        "isOptional": true
      },
      "type": {
        "type": [
          "CONTACT",
          "COMPANY",
          "DEAL",
          "TICKET",
          "TASK",
          "VISIT"
        ],
        "isOptional": true
      }
    },
    "namespace": "crm"
  },
  "indexPageActivation": {
    "name": "first view crm index",
    "class": "activation",
    "namespace": "crm"
  },
  "savedFilterActivation": {
    "name": "load first saved filter",
    "class": "activation",
    "properties": {
      "type": {
        "type": [
          "contact",
          "company",
          "deal",
          "ticket",
          "visit"
        ],
        "isOptional": true
      }
    },
    "namespace": "crm"
  },
  "useFilters": {
    "name": "index interaction",
    "class": "usage",
    "properties": {
      "action": "string",
      "subAction": "string",
      "type": [
        "contacts",
        "companies",
        "deals",
        "tickets",
        "visits"
      ],
      "property": {
        "type": "string",
        "isOptional": true
      },
      "filter": {
        "type": "string",
        "isOptional": true
      },
      "isFirstTime": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "crm"
  },
  "record-interaction": {
    "name": "record-interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "subAction": {
        "type": "string",
        "isOptional": true
      },
      "type": {
        "type": "string",
        "isOptional": true
      },
      "label": {
        "type": "string",
        "isOptional": true
      },
      "count": {
        "type": "number",
        "isOptional": true
      },
      "step": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "crm"
  },
  "recordUsage": {
    "name": "record interaction",
    "class": "usage",
    "properties": {
      "action": "string",
      "subAction": {
        "type": "string",
        "isOptional": true
      },
      "location": {
        "type": "string",
        "isOptional": true
      },
      "type": {
        "type": "string",
        "isOptional": true
      },
      "what_value": {
        "type": "number",
        "isOptional": true
      },
      "property_name": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "crm"
  },
  "playbookInteraction": {
    "name": "record interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "engagementType": "string",
      "activityType": {
        "type": "string",
        "isOptional": true
      },
      "callDisposition": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "crm"
  },
  "recordInteractionWithType": {
    "name": "record interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "type": "string"
    },
    "namespace": "crm"
  },
  "openIntegrationIframeInTimeline": {
    "name": "record-interaction",
    "class": "interaction",
    "properties": {
      "applicationName": {
        "type": "string"
      }
    },
    "namespace": "crm"
  },
  "timelineCardInteraction": {
    "name": "record interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "subAction": "string",
      "eventType": "string",
      "type": [
        "CONTACT",
        "COMPANY",
        "DEAL",
        "TICKET"
      ]
    },
    "namespace": "crm"
  },
  "communicatorFullScreenInteraction": {
    "name": "record interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "expand to full screen",
        "save engagement in full screen"
      ],
      "type": [
        "NOTE",
        "EMAIL",
        "LOGGED-CALL",
        "LOGGED-EMAIL",
        "LOGGED-MEETING"
      ]
    },
    "namespace": "crm"
  },
  "joinMeInteraction": {
    "name": "record interaction",
    "class": "interaction",
    "properties": {
      "action": "string"
    },
    "namespace": "crm"
  },
  "productExperimentExposure": {
    "name": "product experiment exposure",
    "class": "interaction",
    "properties": {
      "experimentName": "string",
      "experimentParams": "string",
      "version": "string"
    },
    "namespace": "crm"
  },
  "sidebarInteraction": {
    "name": "record interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "subAction": "string"
    },
    "namespace": "crm"
  },
  "ticketsActivation": {
    "name": "tickets activation",
    "class": "activation",
    "namespace": "crm"
  },
  "ticketsDayZero": {
    "name": "tickets day zero",
    "class": "activation",
    "namespace": "crm"
  },
  "virality-sent-email-with-brand-banner": {
    "name": "virality",
    "class": "interaction",
    "properties": {
      "action": "string",
      "loop": "string"
    },
    "namespace": "crm"
  },
  "virality-removed-brand-banner": {
    "name": "virality",
    "class": "interaction",
    "properties": {
      "action": "string",
      "loop": "string"
    },
    "namespace": "crm"
  },
  "use-bulk-double-opt-in": {
    "name": "use-bulk-double-opt-in",
    "class": "usage",
    "namespace": "crm"
  },
  "createTask": {
    "name": "create task",
    "class": "interaction",
    "properties": {
      "action": {
        "type": [
          "task created"
        ]
      },
      "createMethod": {
        "type": [
          "manual",
          "automatic"
        ]
      },
      "createSource": {
        "type": "string",
        "isOptional": true
      },
      "reminderType": {
        "type": [
          "absolute",
          "relative"
        ],
        "isOptional": true
      },
      "relativeReminderOption": {
        "type": "number",
        "isOptional": true
      },
      "hasAssociations": {
        "type": "boolean",
        "isOptional": true
      },
      "priority": {
        "type": [
          "HIGH",
          "NONE"
        ],
        "isOptional": true
      }
    },
    "namespace": "crm"
  },
  "changeFollowUpTaskDate": {
    "name": "create task",
    "class": "interaction",
    "properties": {
      "action": [
        "changed date"
      ],
      "customDate": "boolean"
    },
    "namespace": "crm"
  },
  "completedTask": {
    "name": "complete task",
    "class": "interaction",
    "properties": {
      "action": [
        "mark as complete",
        "mark as incomplete",
        "bulk mark as complete"
      ],
      "version": {
        "type": [
          "control",
          "tasks-usability-beta"
        ],
        "isOptional": true
      }
    },
    "namespace": "crm"
  },
  "sentFirstCrmEmail": {
    "name": "sent first crm email",
    "class": "activation",
    "namespace": "crm"
  },
  "selectedActionsRedesignOption": {
    "name": "record interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "opened communicator from activity redesign"
      ],
      "subAction": {
        "type": [
          "email",
          "logged email",
          "note",
          "activity",
          "call",
          "logged call",
          "schedule",
          "logged meeting",
          "task",
          "sequence"
        ]
      },
      "source": [
        "record actions dropdown",
        "keyboard shortcut menu"
      ]
    },
    "namespace": "crm"
  },
  "communicationSubscriptionCardInteraction": {
    "name": "record interaction",
    "class": "interaction",
    "properties": {
      "action": {
        "type": [
          "open current subscriptions",
          "open add subscription",
          "open subscription history"
        ]
      }
    },
    "namespace": "crm"
  },
  "sample-contact-failure": {
    "name": "sample-contact-failure",
    "class": "interaction",
    "namespace": "crm"
  },
  "saved-properties": {
    "name": "saved-properties",
    "class": "interaction",
    "properties": {
      "type": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "crm"
  }
};